import * as React from 'react';
import Header from '../Header';
import PanelContext from '../../PanelContext';
import { formatValue } from '../../utils/dateUtil';
function TimeHeader(props) {
    const { hideHeader } = React.useContext(PanelContext);
    if (hideHeader) {
        return null;
    }
    const { prefixCls, generateConfig, locale, value, format } = props;
    const headerPrefixCls = `${prefixCls}-header`;
    return (<Header prefixCls={headerPrefixCls}>
            {value
            ? formatValue(value, {
                locale,
                format,
                generateConfig
            })
            : locale.timeSelector}
        </Header>);
}
export default TimeHeader;
